// extracted by mini-css-extract-plugin
export default {"errorHeader":"styles_errorHeader__Al9v1"};